import {DateRangeDto} from './DateRangeDto';

export class smsSearchDTO{
  public dateRangeDto: DateRangeDto;
  public mobile : string;
}
